import { CURRENCY, FOREIGN_CURRENCY, inDollars } from '@/domain';

/**
 * A sum as every screen says it: grouped in the reader's own way, with two
 * decimal places at the most and none when the sum is whole.
 *
 * One function for the receipt, the price list's questions and the
 * accountant's before and after (the request of 5 October 2026 (third),
 * sections 2 and 3), so the same price never reads two ways on two screens.
 * The bare figure, for a field or a sentence that says its currency itself;
 * `formatAmount` says it with the currency.
 */
export function formatMoney(value: number): string {
  return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

/**
 * How a reader has chosen to read amounts: in dirhams, the system's money, or
 * in dollars at the rate Accounts set. The lab's request of 17 October 2026,
 * item 13. Without a rate, dollars cannot be shown, and dirhams are.
 */
export interface MoneyView {
  inDollars: boolean;
  /** How many dirhams one dollar buys, or null while Accounts have set none. */
  rate: number | null;
}

export const IN_DIRHAMS: MoneyView = { inDollars: false, rate: null };

/**
 * An amount with its currency: "AED 1,900", or for a reader who chose dollars,
 * "USD 517.36" at the rate, always to the cent. Every amount is kept in
 * dirhams; dollars are only ever shown.
 */
export function formatAmount(dirhams: number, view: MoneyView = IN_DIRHAMS): string {
  if (view.inDollars && view.rate !== null && view.rate > 0) {
    const dollars = inDollars(dirhams, view.rate);
    return `${FOREIGN_CURRENCY} ${dollars.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return `${CURRENCY} ${formatMoney(dirhams)}`;
}
